import React, { useEffect, useState, useContext } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { MessageContext } from "../../MessageContext"
import { Button } from '@material-ui/core';


export default function SimpleTable(props) {

    const [eventAttendees, setEventAttendees] = useState([])
    const messageContext = useContext(MessageContext)
    const [forceRefresh, setForceRefresh] = useState(0)
    const [page, setPage] = useState(0)

    useEffect(() => {
        setPage(0)
        setForceRefresh(forceRefresh + 1)
    }, [props.submittedSearchString]) 
 
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_CALL}/user_events_search/${props.event.id}?search_string=${props.submittedSearchString}&page=${page}`, {
            credentials: 'include'
        })
            .then(response => response.json())
            .then(attendees => {
                console.log("GETTING FROM BACKEND: ", attendees)
                setEventAttendees(attendees)
            })
    }, [props.event, forceRefresh, page])


    const handleRoleChange = (event, id) => {
        console.log("Changing role", event.target.value)
        fetch(`${process.env.REACT_APP_API_CALL}/user_events/${id}`, {
            method: "PATCH",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                role: event.target.value
            })
        })
            .then(response => response.json())
            .then(response => {
                if (response.errors) {
                    messageContext.showErrorMessage(response.errors)
                } else {
                    messageContext.showSuccessMessage("Role has been changed")
                    setForceRefresh(forceRefresh + 1)
                }
            })
    }

    console.log("PAGE NUMBER: ", page)

    return (
        <>
        
        <TableContainer component={Paper}>
        <Table aria-label="simple table">
            <TableHead>
            <TableRow>
                <TableCell>Attendee Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Role</TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
            {eventAttendees.map((user_event) => (
                
                <TableRow key={user_event.id}>
                <TableCell>{user_event.user.name}</TableCell>
                <TableCell>{user_event.user.email}</TableCell>
                <TableCell>
                    <select value={user_event.role} onChange={(event) => handleRoleChange(event, user_event.id)}>
                        <option value="Admin">Admin</option>
                        <option value="Attendee">Attendee</option>
                        <option value="Speaker">Speaker</option>
                        <option value="Sponsor">Sponsor</option>
                    </select>  
                </TableCell>
                </TableRow>
            ))}
            </TableBody>

        </Table>
        </TableContainer>
    
       
        <Button onClick={() => setPage(page - 1)} disabled={page === 0} variant="contained" color="primary">Previous</Button>     
        <Button onClick={() => setPage(page + 1)} variant="contained" color="primary">Next</Button>
        </>
        
    );
}
